import React from 'react'
import {NavigationItem} from './NavigationItems/NavigationItem'

export const NavigationItems = (props) => {
    return (
        <div>
            <section className="text-center mt-8">
                <NavigationItem tooltipHandler={props.tooltipHandler}link="/home" >HOME</NavigationItem>
                <NavigationItem tooltipHandler={props.tooltipHandler}link="/destination" >DESTINATION</NavigationItem>
                <NavigationItem tooltipHandler={props.tooltipHandler}link="/crew" >CREW</NavigationItem>
                <NavigationItem tooltipHandler={props.tooltipHandler}link="/technology" >TECHNOLOGY</NavigationItem>
            </section>
        </div>
    )
}
